import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "labElementForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "Symbol", required: true },
                model: {
                  value: _vm.labElement.symbol,
                  callback: function ($$v) {
                    _vm.$set(_vm.labElement, "symbol", $$v)
                  },
                  expression: "labElement.symbol",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Name", required: false },
                model: {
                  value: _vm.labElement.element_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.labElement, "element_name", $$v)
                  },
                  expression: "labElement.element_name",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Chinese Name", required: false },
                model: {
                  value: _vm.labElement.chinese_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.labElement, "chinese_name", $$v)
                  },
                  expression: "labElement.chinese_name",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Thai Name", required: false },
                model: {
                  value: _vm.labElement.thai_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.labElement, "thai_name", $$v)
                  },
                  expression: "labElement.thai_name",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }